import { internalNetworkClient } from '@terra/shared-rest-clients-internal-network';
import type { InternalNetworkContract } from '@terra/shared-contracts-internal-network';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

type NetworkEnrollmentParams = {
  networkId: string;
  enrollmentId: string;
};

export const internalNetworkEnrollmentApi = {
  createInternalNetworkEnrollment: (networkId: string) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.createEnrollment>({
      endpointFn: (headers) =>
        internalNetworkClient.createEnrollment({
          params: { networkId },
          body: {},
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  revokeInternalNetworkEnrollment: ({
    networkId,
    enrollmentId,
  }: NetworkEnrollmentParams) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.revokeEnrollment>({
      endpointFn: (headers) =>
        internalNetworkClient.revokeEnrollment({
          params: { networkId, enrollmentId },
          body: {},
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  rotateInternalNetworkEnrollmentKey: ({
    networkId,
    enrollmentId,
  }: NetworkEnrollmentParams) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.rotateEnrollmentKey>({
      endpointFn: (headers) =>
        internalNetworkClient.rotateEnrollmentKey({
          params: { networkId, enrollmentId },
          body: {},
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  getInternalNetworkDeploymentRequirements: () =>
    tenantAwareApiWrapper<
      typeof InternalNetworkContract.getDeploymentRequirements
    >({
      endpointFn: (headers) =>
        internalNetworkClient.getDeploymentRequirements({
          ...withOrchestratorClient(headers),
        }),
    }),

  getLatestInternalNetworkSensorRelease: () =>
    tenantAwareApiWrapper<
      typeof InternalNetworkContract.getLatestSensorRelease
    >({
      endpointFn: (headers) =>
        internalNetworkClient.getLatestSensorRelease({
          ...withOrchestratorClient(headers),
        }),
    }),

  listInternalNetworkTunnelEnrollments: (networkId: string) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.listTunnelEnrollments>(
      {
        endpointFn: (headers) =>
          internalNetworkClient.listTunnelEnrollments({
            params: { networkId },
            ...withOrchestratorClient(headers),
          }),
      },
    ),

  createInternalNetworkTunnelEnrollment: ({
    networkId,
    advertisedRoutes,
  }: {
    networkId: string;
    advertisedRoutes?: string[];
  }) =>
    tenantAwareApiWrapper<
      typeof InternalNetworkContract.createTunnelEnrollment
    >({
      endpointFn: (headers) =>
        internalNetworkClient.createTunnelEnrollment({
          params: { networkId },
          body: advertisedRoutes ? { advertisedRoutes } : {},
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  reprovisionInternalNetworkTunnelEnrollmentArtifacts: ({
    networkId,
    enrollmentId,
  }: NetworkEnrollmentParams) =>
    tenantAwareApiWrapper<
      typeof InternalNetworkContract.reprovisionTunnelEnrollmentArtifacts
    >({
      endpointFn: (headers) =>
        internalNetworkClient.reprovisionTunnelEnrollmentArtifacts({
          params: { networkId, enrollmentId },
          body: {},
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  revokeInternalNetworkTunnelEnrollment: ({
    networkId,
    enrollmentId,
  }: NetworkEnrollmentParams) =>
    tenantAwareApiWrapper<
      typeof InternalNetworkContract.revokeTunnelEnrollment
    >({
      endpointFn: (headers) =>
        internalNetworkClient.revokeTunnelEnrollment({
          params: { networkId, enrollmentId },
          body: {},
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),
};
